import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, Events } from 'ionic-angular';
import { PageRef } from '../../../../core/core.module';
import { EventCodes } from '../../../../core/codes';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';

@Component({
	selector: 'page-signup',
	templateUrl: 'signup.html'
})

export class SignupPage extends PageBase {
	public signup: {displayName?:string, email?: string, password?: string} = {};
	public submitted = false;
	public formMsg: any;
	
	constructor(
    	public params: NavParams,
    	public viewCtrl: ViewController,
    	public userData: UserData,
    	public events: Events,
    	public nav: NavController,
    	public settings: AppSettings,
    	public pageRef: PageRef
    ) {	
    	super(settings, events, nav, userData);
    	this.events.subscribe(EventCodes.USER_LOGIN, ()=>{
    		this.goBack();
			//this.dismiss();
		});
		this.events.subscribe(EventCodes.USER_LOGIN_ERROR, (err)=>{
			this.formMsg = err;
		});
    }

	ionViewDidEnter() {
		
	}

	public dismiss() {
		this.viewCtrl.dismiss();
	}

	public onSignup(form){
		this.submitted = true;
		if(form.valid){
			this.userData.signup(this.signup.displayName, this.signup.email, this.signup.password).subscribe();
		}
	}
	public goBack(){
		var prev = this.nav.getPrevious();
		if(prev && prev.id=="login"){
			this.nav.removeView(prev);
			this.goBack();
		}
		else if(prev){
			this.nav.pop();
		} else{
			this.nav.setRoot(this.pageRef.get(''))
		}

	}
}



// WEBPACK FOOTER //
// ./src/modules/account/pages/signup/signup.ts